module.exports = __webpack_public_path__ + "img/brent-martelli.9ec0b828.jpg";